<div class="deleteTopHeader">
    <div class="delete_add_title fs-20">{{'common.text_address_delete_popup_title'|cxTranslate}}</div>
    <div class="delete_close_icon" mat-dialog-close><img src="/icons/close-light-grey.svg" alt="Close Popup"
            width="20px">
    </div>
</div>
<div class="paddingSpacer">
    <mat-dialog-content>

        <p class="fs-20">{{'common.text_address_remove_following'|cxTranslate}}</p>
        <p class="main-address-field fs-20">
            {{_data?.address.sapCustomerID}}<br>
            {{_data?.address.companyName}}<br>
            {{_data?.address.line1}}<br>
            {{_data?.address.postalCode}}
            ,&nbsp;{{_data?.address.town}}<br>{{_data?.address.country?.name}}<br>
        </p>

    </mat-dialog-content>
    <mat-dialog-actions>
        <div class=" d-flex flex-column downButtons">
            <a class="btn button delete-address-btn"
                (click)="deleteAddress(_data.address.id)">{{'common.text_address_delete'|cxTranslate}}<img
                    class="hover-img" src="/icons/link-grey.svg" style="width: 24px;">
            </a>
            <a mat-dialog-close class=" btn button-launch">{{'common.text_button_cancel'|cxTranslate}}</a>
        </div>
    </mat-dialog-actions>
</div>